export const TRIPLE_BOT_SIDES = [
  { id: 'SELL', name: 'sell-buy-sell' },
  { id: 'BUY', name: 'buy-sell-buy' },
]
